{
  "buildId": 1744097645,
  "integrations": {
    "bazaarvoice": {
      "env": "production",
      "user": "oralb-es_es",
      "loader": "main_site_new"
    },
    "syndigo": {
      "site_id": "a1db6f85-179a-48e0-999a-354df095328e"
    },
    "jebbitId": "6DzQSUZ7SPcSfd6Oy0dhJK",
    "c360": {
      "newsletter_selection": {
        "enabled": true,
        "title": "¿Qué tipo de cepillo usa?",
        "selections": [
          {
            "image": "assets/images/newsletter/Manual.png",
            "text": "Cepillo de dientes Manual",
            "value": "Manual"
          },
          {
            "image": "assets/images/newsletter/iO-ETB.png",
            "text": "Cepillo de dientes eléctrico Oral-B iO",
            "value": "Oral-B iO"
          },
          {
            "image": "assets/images/newsletter/OR-ETB.png",
            "text": "Otro cepillo eléctrico de Oral-B",
            "value": "Otro cepillo eléctrico de Oral-B"
          },
          {
            "image": "assets/images/newsletter/Other-Brand.png",
            "text": "Otra marca de cepillo eléctrico",
            "value": "Otra marca de cepillo eléctrico"
          }
        ]
      }
    }
  },
  "GTM": {
    "env": "",
    "keysEnv": "prod",
    "siteEnvironment": "Prod",
    "SiteTouchpoint": "49598",
    "SiteLocalContainer": "GTM-T2RKFF5D",
    "GoogleAnalyticsGA4MeasurementID": "G-QRFTENEM2E",
    "ConsentOverlayID": "htmllang/d9c05e5c-7c37-4392-bb3d-c5a8063b8a5a",
    "marketingProgramNbr": "412",
    "sourceID": "15048",
    "keys": {
      "prod": {
        "rudderstack": "2x2oKxdjH8VXAtxpRVG9W1b3Q2a",
        "segment": "lYbjFeD9KBT7cR1O4VKLdpbIKgpZhHPi"
      },
      "dev": {
        "rudderstack": "2x2qQm2zr5zZCgfuoY1dVzvR7IO",
        "segment": "Z8PdySEceN6DoP2nITiP0rACUDPcrg1T"
      }
    }
  },
  "seo": {
    "store": "Oral-B",
    "og_image": "https://cdn-prod.scalefast.com/public/assets/themes/oral-b-es/images/oralb-og.png",
    "tw_image": "https://cdn-prod.scalefast.com/public/assets/themes/oral-b-es/images/oralb-twitter.png",
    "pages": {
      "404": {
        "title": "Página no encontrada",
        "desc": "La página que estás buscando parece haberse movido, eliminado o no existe."
      },
      "search": {
        "title": "Buscar",
        "desc": "Resultados de la búsqueda"
      },
      "cgv": {
        "title": "Condiciones generales",
        "desc": ""
      },
      "rp": {
        "title": "Política de devolución y derecho de desistimiento",
        "desc": ""
      },
      "privacy": {
        "title": "Política de confidencialidad y cookies",
        "desc": ""
      }
    },
    "homepage_title": "Cepillos de dientes eléctricos, hilo dental & salud dental",
    "desc": "Explora los cepillos de dientes eléctricos, manuales y de batería de Oral-B. Descubre información importante sobre como mantener una buena higiene bucal y una sonrisa saludable."
  },
  "disableThirdPartyScripts": "false",
  "hybridV4Paths": [
    "/account",
    "/cart",
    "/login",
    "/payment",
    "/reset-password",
    "/support",
    "/warranty",
    "/product-popup",
    "/sso_"
  ],
  "contentful": {
    "blocklist": {
      "enabled": true,
      "slugs": [
        "/es-es/coleccion-productos/iscc-plastico-biobasado",
        "/es-es/el-big-rethink",
        "/es-es/coleccion-productos/que-hay-en-nuestra-pasta-de-dientes",
        "/es-es/salud-dental-sostenibilidad",
        "/es-es/seguridad-de-productos-en-pg",
        "/es-es/la-salud-general",
        "/es-es/productos/cepillos-dientes-electricos/genius-x",
        "/es-es/coleccion-productos/aplicacion-oral-b",
        "/es-es/coleccion-productos/oral-b-genius-vs-sonic",
        "/es-es/coleccion-productos/higiene-bucal-en-los-ninos",
        "/es-es/coleccion-productos/consejo-para-la-higiene-oral",
        "/es-es/guia-de-inicio/cepillo",
        "/es-es/join-oralb-io10-waitlist",
        "/es-es/necesidades/proteccion-de-encias",
        "/es-es/necesidades/blanqueamiento",
        "/es-es/necesidades/sensibilidad-dental",
        "/es-es/necesidades/dientes-fuertes",
        "/es-es/necesidades/salud-del-esmalte",
        "/es-es/necesidades/mal-aliento",
        "/es-es/necesidades/sarro-y-placa",
        "/es-es/necesidades/caries-dental",
        "/es-es/contact-us",
        "/es-es/necesidades/brackets-y-ortodoncia",
        "/es-es/spotlight",
        "/es-es/sitemap",
        "/es-es/search",
        "/es-es/Mimejorcepillo",
        "/es-es/paginaderestablecimientodecontrasena",
        "/es-es/register-product",
        "/es-es/change-password",
        "/es-es/profile",
        "/es-es/loginpage",
        "/es-es/congratulations",
        "/es-es/confirm-product",
        "/es-es/create-profile",
        "/es-es/mwc2021media",
        "/es-es/recommendedbrush",
        "/es-es/MiCepilloOralB",
        "/es-es/coleccion-productos/soluciones-de-encias",
        "/es-es/coleccion-productos/que-contiene-nuestra-pasta-de-dientes",
        "/es-es/white-strips",
        "/es-es/cavities-tooth-decay",
        "/es-es/conditions/dry-mouth",
        "/es-es/collection/floss",
        "/es-es/oral-health/why-oral-b/products"
      ]
    }
  },
  "dotPathsEnabled": false,
  "hideCrossedPrice": false,
  "bundleCrossedPriceIsRecommendedPrice": true,
  "freeShippingValue": 39.9,
  "freeShippingFeeds": [
    71638,
    71664,
    72897
  ],
  "helpUrl": {
    "contact": "https://oral-bshop.zendesk.com/hc/es",
    "service": "https://www.service.oralb.com/es/es/"
  },
  "pohFeeds": [
    71638,
    71664
  ],
  "pohUrl": "/cuponprofesionalesdentales",
  "showFromInMetaProductPrices": true,
  "showPricesOnComparisonProducts": true,
  "newsletterTrackers": {
    "newsletter-footer": "OralB_footerEmail",
    "newsletter-modal": "OralB_popup"
  }
}